import Vue from "vue";
import Router from "vue-router"

const Login = () => import("@/views/web/login")
const index = () => import("@/views/web/index")

//客户预约组件
const client = () => import("@/views/web/client/appointment")

//呼叫中心组件
const callcenter_book = () => import("@/views/web/callCenter/book")
const callcenter_detail = () => import("@/views/web/callCenter/clientInfo")
const callcenter_feedback = () => import("@/views/web/callCenter/feedback")

//护士组件
const nurse_book = () => import("@/views/web/nurse/book")
const nurse_detail = () => import("@/views/web/nurse/basicInfo")
const nurse_check = () => import('@/views/web/nurse/check')

//医生组件
const doctor_book = () => import("@/views/web/doctor/book")
const doctor_arrival = () => import("@/views/web/doctor/arrival")
const doctor_check = () => import("@/views/web/doctor/check")
const doctor_feedback = () => import("@/views/web/doctor/feedback")
const doctor_detail = () => import("@/views/web/doctor/basicInfo")



//移动端
const appLogin = () =>  import('@/views/mobile/login')
const verifyCode = () => import('@/views/mobile/client/verifyCode')
// const appIndex = () =>  import('@/views/mobile/index')
const appMain = () =>  import('@/views/mobile/client/index')
const timeSelect = () =>  import('@/views/mobile/client/timeSelect')
const appBasicInfo = () =>  import('@/views/mobile/client/basicInfo')
const appAbsoluteContradictions = () =>  import('@/views/mobile/client/absoluteContradictions')
const medicalHistory = () =>  import('@/views/mobile/client/medicalHistory')
const appointment = () =>  import('@/views/mobile/client/appointment')
const appointmentResult = () =>  import('@/views/mobile/client/appointmentResult')
const appointmentRecord = () =>  import('@/views/mobile/client/appointmentRecord')
const appointmentDetail = () =>  import('@/views/mobile/client/appointmentDetail')
const checkReport = () => import('@/views/mobile/client/checkReport')
const instructions = () => import('@/views/mobile/client/instructions')
const disclaimer = () => import('@/views/mobile/client/disclaimer')



//debug : NavigationDuplicated: Avoided redundent nabigation tocurrent location:
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// Router.prototype.beforeEach = ((to, from, next) => {
  // next()
  // if ( to.name !== 'Login' && !this.$store.state.isAuthenticated ) next({ name: 'Login' })
  // else next()
// })

Vue.use(Router);


export default new Router({
  mode:'history',
  // mode:'hash',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/Login",
    },
//web端
    //登录
    {
      path: "/Login",
      name: "Login",
      component: Login,
    },
    //客户
    {
      path: "/client/index",
      name: "客户",
      component: client,
    },
    //工作人员、管理员后台界面
    {
      path: "/index",
      name: "首页",
      component: index,
      iconCls: "el-icon-tickets",
      children: [
        //呼叫中心
        {
          path: "/callCenter/book",
          name: "信息管理-预约阶段",
          component: callcenter_book,
        },
        {
          path: "/callCenter/clientInfo/view",
          name: "信息管理-预约阶段-查看",
          component: callcenter_detail,
        },
        {
          path: "/callCenter/feedback",
          name: "信息管理-检查反馈",
          component: callcenter_feedback,
        },
        //护士
        {
          path: "/nurse/book",
          name: "检查信息-预约阶段",
          component: nurse_book,
        },
        {
          path: "/nurse/check",
          name: "检查信息-检查阶段",
          component: nurse_check,
        },
        {
          path: "/nurse/basicInfo",
          name: "检查信息-详细信息",
          component: nurse_detail,
        },
        //医生
        {
          path: "/doctor/book",
          name: "判读信息-预约阶段",
          component: doctor_book,
        },
        {
          path: "/doctor/arrival",
          name: "判读信息-到达阶段",
          component: doctor_arrival,
        },
        {
          path: "/doctor/check",
          name: "判读信息-检查阶段",
          component: doctor_check,
        },
        {
          path: "/doctor/feedback",
          name: "判读信息-检查追踪",
          component: doctor_feedback,
        },
        {
          path: "/doctor/basicInfo",
          name: "判读信息-详情",
          component: doctor_detail,
        },
      ],
    },



//移动端
    {
      path: "/appLogin",
      name: "appLogin",
      component: appLogin,
    },
    {
      path: "/appLogin/verifyCode",
      name: "verifyCode",
      component: verifyCode,
    },
    {
      path: "/appIndex/main",
      name: "appMain",
      component: appMain,
    },
    {
      path: "/appIndex/timeSelect",
      name: "timeSelect",
      component: timeSelect,
    },
    {
      path: "/appIndex/basicInfo",
      name: "appBasicInfo",
      component: appBasicInfo,
    },
    {
      path: "/appIndex/absoluteContradictions",
      name: "appAbsoluteContradictions",
      component: appAbsoluteContradictions,
    },
    {
      path: "/appIndex/medicalHistory",
      name: "medicalHistory",
      component: medicalHistory,
    },
    {
      path: "/appIndex/appointment",
      name: "appointment",
      component: appointment,
    },
    {
      path: "/appIndex/appointmentResult",
      name: "appointmentResult",
      component: appointmentResult,
    },
    {
      path: "/appIndex/appointmentRecord",
      name: "appointmentRecord",
      component: appointmentRecord,
    },
    {
      path: "/appIndex/appointmentDetail",
      name: "appointmentDetail",
      component: appointmentDetail,
    },
    {
      path: "/appIndex/checkReport",
      name: "checkReport",
      component: checkReport,
    },
    {
      path: "/appIndex/instructions",
      name: "instructions",
      component: instructions,
    },
    {
      path: "/appIndex/disclaimer",
      name: "disclaimer",
      component: disclaimer,
    },

  ],
});
